export default __webpack_public_path__ + "static/media/save_icon.517cea1f.svg";